export const DEFAULT_CONTENTFUL_ENVIRONMENT_NAME = 'master'
export const DEFAULT_TENANT = 'vistaprint'
export const CONTENTFUL_PAGE_TYPE = 'pageCategoryPageV3'
export const SERVICE_NAME = 'category-page'
export const DEFAULT_URL_ID = 'businessCards'
export const DEVELOPMENT_ENV = 'development'
export const PRODUCTION_ENV = 'production'
export const BFF_CACHE_TTL = 600
export const BFF_CACHE_CHECK_PERIOD = 900
export const REGION_LOCALE: Record<string, string[]> = {
  ANZS: ['en-AU', 'en-NZ', 'en-SG'],
  NA: ['en-US', 'es-US', 'fr-CA', 'en-CA'],
  IN: ['en-IN']
}
export const SPACE_IDS: Record<string, string> = {
  ANZS: '9yjwzxk07tr8',
  EU: 'olowdmhx072v',
  IN: 'vutkdqi6trjg',
  NA: 'p0rr4c9t7js3'
}
